export default __webpack_public_path__ + "static/media/bmw.851b3dd7.svg";